import api from "@/services/apiClient";
import type { GetAllsAlertsIntr } from "../types/securityAlerts.types";
export const securityAlertsService = {
  GetAllSecurityAlerts: (Tz: string): Promise<GetAllsAlertsIntr[]> =>
    api
      .get("SecurityAlerts/GetSecurityAlerts?TimeZone=" + Tz)
      .then((res) => res.data),
  GetServices: (): Promise<string[]> =>
    api.get("SecurityAlerts/GetServices").then((res) => res.data),
  GetStatus: (): Promise<string[]> =>
    api.get("SecurityAlerts/GetStatus").then((res) => res.data),
};
